.field {
  color: var(--comp-checkbox-text-color);
  cursor: pointer;
  display: flex;
  margin-bottom: 0.5rem;
  position: relative;
  transform: opacity .3s ease-in-out;
  user-select: none;
}

.disabled {
  opacity: 0.25;
}

.box {
  align-items: center;
  border: solid 2px var(--comp-checkbox-color);
  display: flex;
  height: 1.2rem;
  justify-content: center;
  margin-right: 0.5rem;
  min-width: 1.2rem;
  position: relative;
}

.box > svg {
  color: transparent;
}

.input {
  appearance: none;
  outline: none;
  position: absolute;
  width: 0;
}

.input[type="checkbox"] ~ .box {
  border-radius: 0.2rem;
}

.input[type="radio"] ~ .box {
  border-radius: 50%;
}

.input[type="checkbox"]:checked ~ .box {
  background: var(--comp-checkbox-color);
}

.input[type="checkbox"]:checked ~ .box > svg {
  color: var(--theme-white);
}

.input[type="radio"]:checked ~ .box {
  background: var(--comp-checkbox-color);
}

.input[type="radio"]:checked ~ .box > svg {
  color: var(--theme-white);
}
